// The panel portal (investor, partner and staff sign-in on one screen) answers on
//   app.<domain>        -> its own host; every path on that host is the portal
//   /app on the main site -> kept for previews and local development
//   /muhasebe             -> old accounting address, forwards to /app
// When REACT_APP_PANEL_URL is set (https://app.<domain>), the main-site paths redirect there so
// production serves the portal from one origin only.

const PANEL_URL = (process.env.REACT_APP_PANEL_URL || "").trim().replace(/\/+$/, "");

export const isPanelHost = (hostname = window.location.hostname) => /^app\./i.test(hostname);

const under = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);
export const isPanelPath = (pathname) => under(pathname, "/app");
export const isLegacyAccPath = (pathname) => under(pathname, "/muhasebe");

// Where a main-site /app visit should go when the portal has its own host and we are not on it.
export const panelRedirect = (search = "", hash = "") => {
  if (!PANEL_URL) return null;
  let target;
  try { target = new URL(PANEL_URL).hostname; } catch (_) { return null; }
  if (target.toLowerCase() === window.location.hostname.toLowerCase()) return null;
  return `${PANEL_URL}/${search}${hash}`;
};
